import { render, staticRenderFns } from "./CancelRideDialog.vue?vue&type=template&id=05d5e16d&"
import script from "./CancelRideDialog.vue?vue&type=script&lang=js&"
export * from "./CancelRideDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports